import { useTranslation } from "react-i18next";
import { HelpLink } from "./HelpLink";
import { useDocState } from "../core/useDocSelector";
import { getViewType } from "../registry/viewTypes";
import { useViewCtx } from "./useViewCtx";
import { useCoreDoc } from "./useCoreDoc";
import { Pill } from "../ui";

/** M1–M3: the `list` widget on the workspace's core doc, with the task panel beside it. M4 replaces this
 *  page with the device dashboard; the panel stays. */
export function HomePage() {
  const { t } = useTranslation();
  const { handle, workspaceId } = useCoreDoc();
  const { settled, readOnly } = useDocState(handle);
  const ctx = useViewCtx(handle, workspaceId ?? "");
  const list = getViewType("list");

  return (
    <div className="flex min-h-full">
      <div className="mx-auto w-full max-w-4xl px-4 pb-16 pt-5 mid:px-9 mid:pt-8" data-testid="home-list">
        <div className="mb-5 flex items-baseline gap-3">
          <h1 className="text-[26px] font-semibold">{t("nav.list")}</h1>
          <HelpLink page="guides/lists-and-bins/" />
          {readOnly && <Pill tone="warn">{t("sync.readOnly")}</Pill>}
        </div>
        {ctx && list && settled ? (
          <list.Component config={list.defaultConfig} ctx={ctx} />
        ) : (
          <p className="text-neutral-500" role="status">
            {t("session.loading")}
          </p>
        )}
      </div>
    </div>
  );
}
